/* eslint-disable */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DetailGrid, DetailGridItem } from 'components/detail';
import { Pencil } from '@entrata/portals-common/lib/icons';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { LINK_BLUE } from 'constants/theme';
import { ModalControl } from '@entrata/portals-common/lib/components';
import { Btn } from 'components/buttons';
import ChangePassword from 'components/account/ChangePassword';
import EditProfile from 'components/account/EditProfile';

const StyledSection = styled('section')`
  padding-top: 80px;
  position: relative;

  @media only screen and (min-width: 320px) {
    padding-top: 0;

    &::before {
      left: 0;
      top: 30px;
    }
  }
`;
const StyledBtn = styled(Btn)`
  background: transparent;
  border: none;
  color: ${LINK_BLUE};
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  font-size: 18px;
  padding: 8px 8px 2px 8px;
  text-decoration: underline;

  svg {
    padding-left: 16px;
  }
`;
const StyledNameTitle = styled('p')`
  font-size: 32px !important;
  color: ${({ theme }) => theme.secondary.dark};
  margin-bottom: 0;
  margin-top: 0;
  font-family: ${({ theme }) => theme.fonts.algebraLight} !important;
`;

const StyledH2 = styled('h2')`
  color: ${({ theme }) => theme.text.dark};
  font-family: ${({ theme }) => theme.fonts.soehneKraftig};
  font-size: 18px;
  display: inline-block;
  margin-right: 24px;
`;

const StyledSpan = styled('span')`
  cursor: pointer;
  color: ${({ theme }) => theme.secondary.dark};
`;

const StyledDetailedGridItem = styled(DetailGridItem)`
  font-family: ${({ theme }) => theme.fonts.soehneBuch};
  color: ${({ theme }) => theme.text.dark};
  font-size: 18px;
`;

const UserInfo = ({ email, fullName, phoneNumber, nameFirst }) => (
  <StyledSection>
    <StyledNameTitle>{`Hi, ${nameFirst}!`}</StyledNameTitle>
    <StyledH2>Contact Info</StyledH2>
    <ModalControl>
      {({ onClick, ref, ...props }) => (
        <>
          <StyledSpan onClick={onClick} ref={ref}>
            <Pencil size={15} />
          </StyledSpan>
          <EditProfile {...props} />
        </>
      )}
    </ModalControl>
    <DetailGrid>
      <StyledDetailedGridItem name='Name' value={fullName} />
      <StyledDetailedGridItem name='Email' value={email} />
      <StyledDetailedGridItem name='Phone' value={phoneNumber} />
      <StyledDetailedGridItem
        name=''
        value={
          <ModalControl>
            {({ onClick, ref, ...props }) => (
              <Fragment>
                <StyledBtn onClick={onClick} ref={ref}>
                  Change Password
                </StyledBtn>
                <ChangePassword {...props} />
              </Fragment>
            )}
          </ModalControl>
        }
      ></StyledDetailedGridItem>
    </DetailGrid>
  </StyledSection>
);

UserInfo.propTypes = {
  email: PropTypes.string,
  fullName: PropTypes.string,
  phoneNumber: PropTypes.string,
  nameFirst: PropTypes.string,
};

const mapState = ({ user: { email, nameFirst, nameLast, phoneNumber } }) => ({
  email,
  nameFirst,
  fullName: `${nameFirst} ${nameLast}`,
  phoneNumber: phoneNumber && phoneNumber.toString().replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3'),
});

export default connect(mapState)(UserInfo);
